module.exports = __webpack_public_path__ + "static/img/IMG_0001.cc124e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_slider/IMG_0001.jpg
// module id = Xmc1
// module chunks = 0